import { useVSFContext } from "@vue-storefront/core";

const setKlarnaScript = () => {
  const context = useVSFContext();

  return new Promise((resolve, reject) => {
    if(!context.$config.klarnaPortalUrl) return ;

    const scriptSrc = context.$config.klarnaPortalUrl;
    if (document.getElementById('instalment-marketing')) {
      resolve(true); // Script already exists, no need to add it again
      return;
    }

    const klarna = document.createElement('script');
    klarna.setAttribute('src', scriptSrc);
    klarna.setAttribute('async', 'true');
    klarna.setAttribute('type', 'text/javascript');
    klarna.setAttribute('data-client-id', context.$config.klarnaPortalClientId);
    klarna.setAttribute('data-instalment-threshold', '15')
    klarna.setAttribute('id', 'instalment-marketing')

    klarna.onload = () => {
      console.log('Klarna script loaded');
      resolve(true);
    };

    klarna.onerror = (error) => {
      console.error('Failed to load Klarna script', error);
      reject(error);
    };

    document.head.appendChild(klarna);
  });
};

export default setKlarnaScript

